import { render } from "./profile-v1.vue?vue&type=template&id=fb6e4832&scoped=true"
import script from "./profile-v1.vue?vue&type=script&lang=js"
export * from "./profile-v1.vue?vue&type=script&lang=js"

import "./profile-v1.vue?vue&type=style&index=0&id=fb6e4832&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6e4832"]])

export default __exports__